import BossModel from "@/models/BossModel";
import MarginGroup from "@/models/Margin/MarginGroup/MarginGroup";
import orderBy from 'lodash/orderBy';
import Margin from "@/models/Margin/Margin";
import Country from "@/models/Country/Country";
import Type from "@/models/Product/Type/Type";

export default class MarginVersion extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'margin/version';

    /**
     *
     * @type {string}
     */
    static entity = 'marginVersions';

    static fields() {
		return {
			id: this.number(null).nullable(),
			margin_id: this.number(null).nullable(),
			name: this.attr(null),
			country_id: this.number(null).nullable(),
			product_type_id: this.number(null).nullable(),
			is_active: this.boolean(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
			deleted_at: this.attr(null),
            margin: this.belongsTo(Margin, 'margin_id'),
            groups: this.hasMany(MarginGroup, 'margin_version_id'),
            country: this.belongsTo(Country, 'country_id'),
            productType: this.belongsTo(Type, 'product_type_id'),
		}
	}

    validate() {
        return this.constructor.api().action(this.id + '/validate').getSingle(false);
    }

    activate() {
        return this.constructor.api().action(this.id + '/activate').update();
    }

    Groups() {
        return orderBy(this.getRelated('groups'), ['start', 'end']);
    }

    /**
     *
     * @returns {boolean|*}
     */
    Country(){
        return this.getRelated('country');
    }

    /**
     *
     * @returns {boolean|*}
     */
    ProductType(){
        return this.getRelated('productType');
    }

    static loadAll() {
        return this.api()
            .where('is_active', true)
            .limit(0)
            .get();
    }
}
